import { render, staticRenderFns } from "./DocumentKeywordPreview.vue?vue&type=template&id=bcc2c4e0&"
import script from "./DocumentKeywordPreview.js?vue&type=script&lang=js&"
export * from "./DocumentKeywordPreview.js?vue&type=script&lang=js&"
import style0 from "./DocumentKeywordPreview.vue?vue&type=style&index=0&id=bcc2c4e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports